import axios from "axios";
import { useForm } from "react-hook-form";
import React, {
  Fragment,
  useEffect,
  useState,
  useCallback,
  useContext,
} from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Card,
  CardHeader,
  Modal,
  ModalBody,
  ModalHeader,
  CardBody,
  Row,
  Col,
  Label,
  ModalFooter,
  Form,
} from "reactstrap";
import Select from "react-select";
import { Btn, H4, P } from "../../../../../AbstractElements";
import { Close, Save } from "../../../../../Constant";
import BookingModal from "./TreatmentBookingModal";
import {
  DeleteTreatmentPlanMapping,
  TreatmentMethodList,
  TreatmentPlanList,
  TreatmentPlanMappingList,
  TreatmentProcedureList,
  UpdateTreatmentPlanMapping,
} from "../../../../../apiController";
import DataTable from "react-data-table-component";
import { Navigator } from "../../../../../Data/Table/Defaultdata";
import { UserContext } from "./exp";
import { toast } from "react-toastify";
import SweetAlert from 'sweetalert2';

const TreatmentMapped = ({permission}) => {

  const treatmentPlanPermission = permission.module_name === "PD Summary"
  // const treatmentPlanPermission = permission.find(module => module.module_name === 'PD Summary')
  
    console.log(treatmentPlanPermission)
  const location = useLocation();
  const [treatmentData, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [toggleDelet, setToggleDelet] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [rows, setRow] = useState([]);
  const [Large, setLarge] = useState(false);

  // const [treatmentdata, setData] = useState([]);
  const [treatmentPlan, setTreatmentPlan] = useState([]);
  const [treatmentProcedure, setTreatmentProcedure] = useState([]);
  const [treatmentMethod, setTreatmentMethod] = useState([]);
  const [filteredTreatmentProcedure, setFilteredTreatmentProcedure] = useState(
    []
  );
  const [filteredTreatmentMethod, setFilteredTreatmentMethod] = useState([]);
  const [treatment, setTreatment] = useState({});

  const { data } = location.state || {};
  const contextValue = useContext(UserContext);

  const LargeModaltoggle = (trt = null, index = -1) => {
    console.log(trt);
    if (trt && trt.patient_treatment) {
      let treatmentData;

      try {
        treatmentData = JSON.parse(trt.patient_treatment);
      } catch (error) {
        console.error("Error parsing treatment data:", error);
        treatmentData = {};
      }

      const selectedPlans = treatmentData.items || [];
      const selectedProcedures = treatmentData.itemsP || [];
      const selectedMethods = treatmentData.itemsPr || [];
      setTreatment({
        ...trt,
        index,
        type: treatmentData.type || "-",
        problem: treatmentData.problem || {},
        tooth: treatmentData.tooth || "-",
      });
      setSelectedOptions(
        selectedPlans.map((item) => ({
          value: item.id,
          label: item.name,
          id: item.id,
          name: item.name,
        }))
      );

      setSelectedOptionsProcedure(
        selectedProcedures.map((item) => ({
          value: item.id,
          label: item.sname,
          id: item.id,
          sname: item.sname,
        }))
      );

      setSelectedOptionsMethod(
        selectedMethods.map((item) => ({
          value: item.id,
          label: item.mname,
          id: item.id,
          doctor_price: item.doctor_price,
          price: item.price,
          mname: item.mname,
        }))
      );
    } else {
      setTreatment({
        type: "-",
        problem: {},
        tooth: "-",
      });
    }

    setLarge(!Large);
  };

  const planOptions = treatmentPlan.map((plan) => ({
    value: plan.id,
    id: plan.id,
    label: plan.treatment_plan,
    name: plan.treatment_plan,
  }));
  const procedureOptions = filteredTreatmentProcedure.map((plan) => ({
    value: plan.id,
    id: plan.id,
    sname: plan.treatment_procedure,
    label: plan.treatment_procedure,
  }));
  const methodOptions = filteredTreatmentMethod.map((plan) => ({
    value: plan.id,
    label: plan.treatment_method,
    id: plan.id,
    mname: plan.treatment_method,
    doctor_price: plan.doctor_price,
    price: plan.method_price,
  }));
  const [items, setSelectedOptions] = useState([]);
  const [itemsP, setSelectedOptionsProcedure] = useState([]);
  const [itemsPr, setSelectedOptionsMethod] = useState([]);

  const handleChange = (selected) => {
    // console.log(selected);
    setSelectedOptions(selected);
  };
  const handleChangeProcedure = (selected) => {
    setSelectedOptionsProcedure(selected);
  };
  const handleChangeMethod = (selected) => {
    setSelectedOptionsMethod(selected);
  };
  const toggleModal = (row) => {
    setRow(row);
    setIsModalOpen(!isModalOpen);
  };

  const treatmentPlanList = treatmentData.filter(t => t.status !== "booked").flatMap((row, ind) => {
    const patientTreatment = JSON.parse(row.patient_treatment);
    const createdDate = new Date(row.created_at);
    const formattedDate = createdDate.toISOString().split("T")[0];

    return {
      ind: ind + 1,
      id: row.id,
      date: formattedDate,
      type:
        patientTreatment.type === "tooth" ? (
          <p>{patientTreatment.tooth}</p>
        ) : (
          patientTreatment.type
        ),
      diagnosis: patientTreatment.problem ? patientTreatment.problem.name : "-",
      treatmentmethod: patientTreatment.itemsPr
        ? patientTreatment.itemsPr.map((t) => t.mname).join(", ")
        : "-",
      price: patientTreatment.itemsPr
        ? patientTreatment.itemsPr.map((t) => t.price).join(", ")
        : "-",
      book: (
        <span>
          <Btn
            attrBtn={{
              className: "focuse-none",
              color: "secondary",
              size: "sm",
              onClick: () => toggleModal(row),
            }}
          >
            {"Book"}
          </Btn>
        </span>
      ),
      edit: (
        <span>
          <Btn
            attrBtn={{
              className: "focuse-none",
              color: "success",
              size: "sm",
              onClick: () => LargeModaltoggle(row, ind),
            }}
          >
            {"Edit"}
          </Btn>
        </span>
      ),
    };
  });

  const tableColumns = [
    {
      name: "#",
      selector: (row) => row["ind"],
      sortable: true,
      center: false,
    },
    {
      name: "Date",
      selector: (row) => row["date"],
      sortable: true,
      center: false,
    },
    {
      name: "Type/ Tooth no",
      selector: (row) => row["type"],
      sortable: true,
      center: true,
    },
    {
      name: "Diagnosis",
      selector: (row) => `${row.diagnosis}`,
      sortable: true,
      center: true,
    },
    {
      name: "Treatment Method",
      selector: (row) => `${row.treatmentmethod}`,
      sortable: true,
      center: true,
    },
    {
      name: "Treament Price",
      selector: (row) => row["price"],
      sortable: false,
      center: true,
    },
    // {
    //   name: "Book",
    //   selector: (row) => row["book"],
    //   sortable: false,
    //   center: true,
    // },
    // {
    //   name: "Edit",
    //   selector: (row) => row["edit"],
    //   sortable: false,
    //   center: true,
    // },
  ];

  if (permission?.create_access) {
    tableColumns.push({
      name: "Book",
      selector: (row) => row["book"],
      sortable: false,
      center: true,
    });
  }
  
  if (permission?.edit_access) {
    tableColumns.push({
      name: "Edit",
      selector: (row) => row["edit"],
      sortable: false,
      center: true,
    });
  }

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();
  useEffect(() => {
    // let isMounted = true;
    // if (isMounted) {
    //   axios.get(TreatmentPlanMappingList).then((res) => setData(res.data));
    // }
    // return () => {
    //   isMounted = false;
    // };
    fetchTreatmentPlanMappingList();
  }, [isModalOpen]);

  const fetchTreatmentPlanMappingList = async () => {
    const response = await TreatmentPlanMappingList();
    if (response.status === true) {
      const filteredList = await response.data.filter(
        (list) => list.patient_id === data.id
      );
      // console.log(response.data)
      // console.log(filteredList)
      setData(filteredList);
    }
  };

  // console.log(data)
  // console.log(treatmentData);
  const fetchTreatmentPlan = async () => {
    const response = await TreatmentPlanList();
    if (response.status === true) {
      let plan = await response.data;

      // //console.log(treatment)
      const filteredPlan = await plan.filter(
        (plan) => plan.diagnosis_id === treatment?.problem?.id
      );
      // //console.log(plan)
      // //console.log(filteredPlan)
      setTreatmentPlan(filteredPlan);
    }
  };
  const fetchTreatmentProcedure = async () => {
    const response = await TreatmentProcedureList();
    if (response.status === true) {
      setTreatmentProcedure(response.data);
    }
  };
  const fetchTreatmentMethod = async () => {
    const response = await TreatmentMethodList();
    if (response.status === true) {
      setTreatmentMethod(response.data);
    }
  };

  useEffect(() => {
    if (treatment?.problem?.id) {
      fetchTreatmentPlan();
    }

    fetchTreatmentMethod();
    fetchTreatmentProcedure();
  }, [treatment]);

  useEffect(() => {
    const filterProcedures = () => {
      if (items) {
        const selectedIds = items.map((option) => option.value);
        // console.log(selectedOptions)
        // console.log(selectedIds)
        // console.log(treatmentProcedure)
        const filtered = treatmentProcedure.filter((procedure) =>
          selectedIds.includes(procedure.treatment_plan_id)
        );
        setFilteredTreatmentProcedure(filtered);
      } else {
        setFilteredTreatmentProcedure(treatmentProcedure);
      }
    };

    filterProcedures();
  }, [items, treatmentProcedure]);
  // console.log(selectedOptionsProcedure)
  useEffect(() => {
    const filterMethod = () => {
      // console.log(selectedOptionsProcedure)
      if (itemsP) {
        const selectedIds = itemsP.map((option) => option.value);
        // console.log(treatmentMethod)
        const filtered = treatmentMethod.filter((method) =>
          selectedIds.includes(method.treatment_procedure_id)
        );
        setFilteredTreatmentMethod(filtered);
      } else {
        setFilteredTreatmentMethod(treatmentMethod);
      }
    };

    filterMethod();
  }, [itemsP, treatmentMethod]);

  const total = itemsPr.reduce((sum, item) => {
    return sum + parseFloat(item.price);
  }, 0);

  const handleSave = async (e) => {
    // e.preventDefault();

    const updatedSelectEdit = {
      data: data,
      type: treatment.type,
      problem: treatment.problem,
      tooth: treatment.tooth,
      index: treatment.index,
      items: items,
      itemsP: itemsP,
      itemsPr: itemsPr,
    };

    console.log(updatedSelectEdit);

    const editPlan = {
      id: treatment.id,
      patient_id: data.id,
      patient_treatment: updatedSelectEdit,
    };

    console.log(editPlan);

    try {
      const response = await UpdateTreatmentPlanMapping(editPlan);
      if (response.status === true) {
        toast.success("Created Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      setLarge(!Large);
      fetchTreatmentPlanMappingList();
      setTimeout(()=>{
        window.location.reload()
      }, 200)
    }
  };

  const handleDelete = async () => {
    const result = await SweetAlert.fire({
      title: 'Are you sure you want to delete?',
      cancelButtonText: 'No!',
      confirmButtonText: 'Yes!',
      reverseButtons: true,
      showCancelButton: true,
    });
  
    if (result.isConfirmed) {
      try {
        const selectedIds = selectedRows.map(row => row.id); 
        await Promise.all(selectedIds.map(id => DeleteTreatmentPlanMapping(id)));
        setSelectedRows([]);
        toast.success('Deleted Successfully!', { position: toast.POSITION.TOP_CENTER });
      } catch (error) {
        toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
      }
      finally{
        fetchTreatmentPlanMappingList()
      }
    }
  };

  const showSelectableRows = treatmentPlanPermission?.delete_access;

  return (
    <Fragment>
      <Card>
        <CardHeader>
          <H4 attrH4={{ className: "card-title mb-0" }}>
            {"Treatment Planned"}
          </H4>
          <div className="card-options">
            <a
              className="card-options-collapse"
              href="#javascript"
              data-toggle="card-collapse"
            >
              <i className="fe fe-chevron-up"></i>
            </a>
            <a
              className="card-options-remove"
              href="#javascript"
              data-toggle="card-remove"
            >
              <i className="fe fe-x"></i>
            </a>
          </div>
        </CardHeader>
        <div className="table-responsive edit-table">
          <Fragment>
        {(selectedRows.length !== 0) &&
                <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                    <H4 attrH4={{ className: 'text-muted m-0' }}>Delet Selected Data..!</H4>
                    <Btn attrBtn={{ color: 'danger', onClick: () => handleDelete() }}>Delete</Btn>
                </div>
            }
          <DataTable
            data={treatmentPlanList}
            columns={tableColumns}
            striped={true}
            center={true}
            pagination
            selectableRows={showSelectableRows}
            onSelectedRowsChange={handleRowSelected}
            clearSelectedRows={toggleDelet}
          />
          </Fragment>
        </div>
      </Card>
      {/* {isModalOpen &&} */}
      <Modal isOpen={isModalOpen} toggle={toggleModal} centered>
        <ModalBody>
          <BookingModal toggle={toggleModal} rows={rows} />
        </ModalBody>
      </Modal>

      <Modal isOpen={Large} toggle={LargeModaltoggle} size="lg" centered>
        <ModalHeader toggle={() => LargeModaltoggle(null, -1)}>
          {"Add Treatment Plan"}
        </ModalHeader>
        <ModalBody className={"bodyClass"}>
          <Card>
            <CardBody>
              <Form className="form-bookmark needs-validation">
                <Row className="mb-3" sm="12">
                  <Col className="d-flex justify-content-center align-items-center gap-2">
                    <Label>{"Diagnosis Type :"}</Label>
                    <P>{treatment.type !== undefined ? treatment.type : "-"}</P>
                  </Col>
                  {treatment.type === "tooth" ? (
                    <Col className="d-flex justify-content-center align-items-center gap-2">
                      <Label>
                        <span>{"Tooth No :"}</span>
                      </Label>
                      <P>{treatment.tooth}</P>
                    </Col>
                  ) : (
                    ""
                  )}
                  <Col className="d-flex justify-content-center align-items-center gap-2">
                    <Label>{"Diagnosis :"}</Label>
                    <P>
                      {treatment.problem !== undefined
                        ? treatment.problem.name
                        : "-"}
                    </P>
                  </Col>
                </Row>

                <Row className="mb-3" sm="12">
                  <Label className="col-form-label">Treatment Plan</Label>
                  <Select
                    options={planOptions}
                    className="js-example-basic-single col-sm-12"
                    onChange={handleChange}
                    isMulti
                    value={items}
                  />
                </Row>
                <Row className="mb-3" sm="12">
                  <Label className="col-form-label">Treatment Procedure</Label>
                  <Select
                    options={procedureOptions}
                    className="js-example-basic-single col-sm-12"
                    onChange={handleChangeProcedure}
                    isMulti
                    value={itemsP}
                  />
                </Row>
                <Row className="mb-3" sm="12">
                  <Label className="col-form-label">Treatment Method</Label>
                  <Select
                    options={methodOptions}
                    className="js-example-basic-single col-sm-12"
                    onChange={handleChangeMethod}
                    isMulti
                    value={itemsPr}
                  />
                </Row>

                <Row sm="12">
                  <Col className="d-flex justify-content-center align-items-center gap-2">
                    <Label>{"Treatment Price"}</Label>
                    <P>{filteredTreatmentMethod.length > 0 ? total : "-"}</P>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
        </ModalBody>
        <ModalFooter>
          <Btn
            attrBtn={{
              color: "secondary",
              onClick: () => LargeModaltoggle(null, -1),
            }}
          >
            {Close}
          </Btn>
          <Btn attrBtn={{ color: "primary", onClick: () => handleSave() }}>
            {Save}
          </Btn>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default TreatmentMapped;
